<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "AdminAdvertWrapper"
    }
</script>

<style scoped>

</style>